import { PropsWithChildren, ReactElement } from 'react';

import { IonListHeader, IonRadioGroup } from '@ionic/react';

import { FormControl, FormControlBaseProps } from '../FormControl';
import { Typography } from '../../Typography/Typography';

import { FormRadioGroupValidation } from './FormRadioGroup.types';
import { FormRadioGroupItem } from './FormRadioGroupItem/FormRadioGroupItem';

import styles from './FormRadioGroup.module.scss';

interface FormRadioGroupProps<T = string>
  extends FormControlBaseProps<FormRadioGroupValidation, T> {}

type FormRadioGroupPropsWithChildren<T = string> = PropsWithChildren<
  FormRadioGroupProps<T>
>;

interface FormRadioGroupComponent {
  <T = string>(props: FormRadioGroupPropsWithChildren<T>): ReactElement;
  Item: typeof FormRadioGroupItem;
}

export const FormRadioGroup: FormRadioGroupComponent = ({
  children,
  ...props
}) => {
  return (
    <FormControl variant="list" type="radioGroup" {...props}>
      {({ value, onChange }) => {
        return (
          <IonRadioGroup value={value} onIonChange={onChange}>
            {props?.label && (
              <IonListHeader className={styles.header}>
                <Typography>{props.label}</Typography>
              </IonListHeader>
            )}
            {children}
          </IonRadioGroup>
        );
      }}
    </FormControl>
  );
};

FormRadioGroup.Item = FormRadioGroupItem;
